import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue'
import { getErrorMessage } from '@/helpers/error-helpers'
import { Potencia } from 'common/types/Potencia'
import PotenciaService from '../services/PotenciaService'


export default /*#__PURE__*/_defineComponent({
  __name: 'SeletorDePotencia',
  props: {
	value: {
		default: null,
		type: [Object, String, Array] as PropType<{
			value: string
			text: string,
		} | null | string>,
	},
},
  emits: ["input"],
  setup(__props) {





const carregando = ref(true)
const erro = ref('')
const itens = ref<Potencia[]>([])

async function carregarPotencias() {
	carregando.value = true
	try {
		itens.value = await PotenciaService.find()
	} catch (e) {
		erro.value = getErrorMessage(e)
	} finally {
		carregando.value = false
	}
}

carregarPotencias()

return { __sfc: true,carregando, erro, itens, carregarPotencias }
}

})